<template>
    <div class="vod-carousel">
        <div class="vod-carousel-title" v-if="title" @click="goToProducts">
            <div>{{ title }}</div>
        </div>
        <div>
            <div
                class="vod-carousel-navigator -left"
                :class="{ '-offset': title }"
            >
                <i @click="moveCarousel('left')" class="material-icons"
                    >keyboard_arrow_left</i
                >
            </div>
            <div class="vod-carousel-content" ref="carousel">
                <div
                    ref="element"
                    class="vod-carousel-element"
                    v-for="(element, index) in content"
                    @click="goToProduct(element)"
                    :key="index"
                >
                    <v-img fit="cover" size="medium" :url="element.thumbnail" />
                </div>
            </div>
            <div
                class="vod-carousel-navigator -right"
                :class="{ '-offset': title }"
            >
                <i @click="moveCarousel('right')" class="material-icons"
                    >keyboard_arrow_right</i
                >
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        type: String,
        content: Array
    },
    methods: {
        goToProduct(product) {
            if (!product.uuid) {
                return
            }
            const base = product.type == 'vod-course' ? '/course' : '/webinar'
            this.$router.push(`${base}/${product.uuid}`)
        },
        goToProducts() {
            this.$router.push(`/webinars/${this.type}`)
        },
        moveCarousel(direction) {
            if (!this.$refs.element) {
                return
            }
            const element = this.$refs.element[0]
            const elementWidth = element.offsetWidth
            const margin = window.getComputedStyle(element)['margin-right']
            const marginRight = parseInt(margin.replace('px', ''))
            if (direction == 'left') {
                this.$refs.carousel.scrollLeft -= elementWidth + marginRight
            } else {
                this.$refs.carousel.scrollLeft += elementWidth + marginRight
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.vod-carousel {
    position: relative;
    width: 100%;
    margin-bottom: 2rem;
    z-index: $low;

    @media (max-width: 1000px) {
        width: 100vw;
    }
}
.vod-carousel-title {
    font-size: 2.5rem;
    font-family: $input-family;
    display: flex;

    div {
        transition: $ease;
        cursor: pointer;
        &:hover {
            transform: $translateY;
        }
    }

    @media (max-width: 1000px) {
        margin-left: 2rem;
    }
}
.vod-carousel-content {
    margin-top: 1rem;
    min-width: 100%;
    max-width: 100%;
    height: 15rem;
    display: flex;
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
}
.vod-carousel-element {
    height: 15rem;
    min-width: 26.7rem;
    max-width: 26.7rem;
    cursor: pointer;
    transition: $ease;

    &:not(:last-of-type) {
        margin-right: 2rem;
    }
}
.vod-carousel-navigator {
    position: absolute;
    top: 0;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: $low;

    &.-offset {
        margin-top: 4rem;
    }

    i {
        font-size: 4rem;
        cursor: pointer;
        transition: $ease;

        &:hover {
            transform: $translateY;
        }
    }
    $background: var(--background);
    &.-left {
        left: 0;
        background: linear-gradient(to left, transparent 0%, $background 100%);
    }
    &.-right {
        right: 0;
        background: linear-gradient(to right, transparent 0%, $background 100%);
    }
}
::-webkit-scrollbar {
    width: 2px;
    height: 2px;
}
@media (max-width: 1000px) {
    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
}
</style>
